<template>
  <div class="filter">
    <div class="filter__layout-toggle">
      <div class="filter__layout-toggle-icons">
        <!--  <span
          class="filter__icon-wrapper"
          :class="{'filter__icon-wrapper--active': isGrid}"
          @click="$emit('gridClicked')"
        >
          <icon-base icon-name="grid">
            <icon-grid></icon-grid>
          </icon-base>
        </span> -->
        <!-- <span
          class="filter__icon-wrapper"
          :class="{'filter__icon-wrapper--active': isList}"
          @click="$emit('listClicked')"
        >
          <icon-base icon-name="list">
            <icon-list></icon-list>
          </icon-base>
        </span> -->
      </div>
      <span
        v-if="itemsQty"
        class="filter__layout-toggle-text"
        v-html="
          $t('common.displayQty', {
            currentValue: itemsQty,
            allResults: itemsQty,
          })
        "
      />
      <slot name="qty" />
    </div>
    <slot />
    <div v-if="isOrderByVisible || optionsList" class="filter__sort-toggle">
      <div
        v-if="isOrderByVisible"
        class="filter__sort-alphabet"
        :class="{ 'filter__sort-alphabet--disabled': isDisabled }"
        @click="$emit('orderByClicked')"
        v-html="getOrderByTitle"
      />
      <!-- eslint-disable vue/no-mutating-props -->
      <multiselect
        v-if="optionsList"
        v-model="optionsList.selected"
        class="multiselect--sub-small filter__sort-option"
        :options="optionsList.options"
        :showLabels="false"
        openDirection="bottom"
        placeholder="Select an Option"
        :allowEmpty="false"
        :searchable="false"
        :disabled="isDisabled"
        :trackBy="optionsList.trackBy"
        :label="optionsList.label"
        @update:modelValue="$emit('sortSelected')"
      />
      <!-- eslint-enable vue/no-mutating-props -->
    </div>
  </div>
</template>
<script>
import IconBase from '@/components/common/IconBase.vue'
import IconGrid from '@/components/common/icons/IconGrid.vue'
import IconList from '@/components/common/icons/IconList.vue'

export default {
  name: 'FilterWrapper',
  components: {
    IconGrid, // eslint-disable-line vue/no-unused-components
    IconList, // eslint-disable-line vue/no-unused-components
    IconBase, // eslint-disable-line vue/no-unused-components
  },
  props: {
    optionsList: {
      type: Object,
      default: () => {},
    },
    itemsQty: {
      type: Number,
      default: 0,
    },
    isGrid: {
      type: Boolean,
      default: false,
    },
    isList: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isOrderByVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['sortSelected', 'orderByClicked'],
  computed: {
    getOrderByTitle() {
      return this.optionsList?.isOrderByDesc
        ? this.$t('common.alphabetSortDesc')
        : this.$t('common.alphabetSortAsc')
    },
  },
}
</script>
